import React from "react"
import Church from "../images/icon_church.png"
import BookStore from "../images/icon_book.png"
import Community from "../images/icon_community.png"
import Grocery from "../images/icon_grocery.png"
import Advertiser from "../images/icon_advertiser.png"
import Market from "../images/icon_market.png"
import { Link } from "gatsby"

export default function PrintDistribution() {
  return (
    <section className="print-distribution-locations">
    <h2
      className="new-directory-head mb-3 text-center"
      style={{
        color: `#005D9D`,
        fontFamily: `Ubuntu, sans-serif`,
        fontSize: "clamp(1.75em, 5vw, 3em",
        fontWeight: `700`,
      }}>
      Print Distribution Locations
    </h2>
    <div className="container">
      <div className="row justify-content-center py-5">
        <div className="col-lg-4 col-md-6 col-12 pb-3 pb-md-5">
          <h3 className="pd_icons">
            <img src={Church} alt="church" />
          </h3>
          <h3 className="h3 text-uppercase mb-3 text-center">churches</h3>
          <p className="text-center px-xl-5">
            Distributed through 100s of churches of various denominations
            throughout each region.
          </p>
        </div>
        <div className="col-lg-4 col-md-6 col-12 pb-3 pb-md-5">
          <h3 className="pd_icons">
            <img src={BookStore} alt="church" />
          </h3>
          <h3 className="h3 text-uppercase mb-3 text-center">
            christian bookstores
          </h3>
          <p className="text-center px-xl-5">
          Various local independent Christian Stores in your area. Check "Bookstores-Christian" category on our website for an updated list of distributors.
          </p>
        </div>
        <div className="col-lg-4 col-md-6 col-12 pb-3 pb-md-5">
          <h3 className="pd_icons">
            <img src={Community} alt="church" />
          </h3>
          <h3 className="h3 text-uppercase mb-3 text-center">
            community events
          </h3>
          <p className="text-center px-xl-5">
            Ministry banquets, Christian concerts and other Christian and
            community events.
          </p>
        </div>
        <div className="col-lg-4 col-md-6 col-12 pb-3 pb-md-5">
          <h3 className="pd_icons">
            <img src={Grocery} alt="church" />
          </h3>
          <h3 className="h3 text-uppercase mb-3 text-center">
            grocery & retail stores
          </h3>
          <p className="text-center px-xl-5">
          Distribution Racks at select Giant Eagle and  CVS stores, plus Busken Bakery and Yagoot locations in Cincinnati.
          </p>
        </div>
        <div className="col-lg-4 col-md-6 col-12 pb-3 pb-md-5">
          <h3 className="pd_icons">
            <img src={Advertiser} alt="church" />
          </h3>
          <h3 className="h3 text-uppercase mb-3 text-center">
            advertiser locations
          </h3>
          <p className="text-center px-xl-5">
            100s of locations of various businesses throughout your area.
          </p>
        </div>
        <div className="col-lg-4 col-md-6 col-12 pb-3 pb-md-5">
          <h3 className="pd_icons">
            <img src={Market} alt="church" />
          </h3>
          <h3 className="h3 text-uppercase mb-3 text-center">
            markets we serve
          </h3>
          <p className="text-center px-xl-5">
            Cincinnati/N Kentucky, Columbus & central Ohio, Greater Dayton, Springfield/Urbana, Indianapolis & central Indiana
          </p>
        </div>
      </div>
    </div>
  </section>
  )
}